module.exports = __webpack_public_path__ + "img/checkedicon.bae934bd.svg";